import React from "react";
import NoDataIcon from "./../../../assets/icons/NoData.svg";

const NoDataSvg = (props) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <img
        src={props.svg ? props.svg : NoDataIcon}
        alt="No data"
        width={props.width ? props.width : 300}
        height={props.height ? props.height : 300}
      />
      {props.text1 && <div className="text-text_light text-lg font-semibold mt-4 text-center">{props.text1}</div>}
      {props.text2 && <div className="mt-2 text-center">{props.text2}</div>}
    </div>
  );
};

export default NoDataSvg;
